import { MouseEvent } from 'react';

/**
 * Focuses the group's control, so clicking anywhere in the box behaves as one
 * field. Clicks on a button are left alone.
 */
export function focusControl(
  event: MouseEvent<HTMLElement>,
  container: HTMLElement | null | undefined
) {
  if ((event.target as HTMLElement).closest('button')) return;

  container?.querySelector<HTMLElement>('input, textarea')?.focus();
}
